import Big from 'big.js'
import { isEmptyString, isNull, isNumber, isUndefined } from 'ramda-adjunct'

export function toFixed(value: number | null | undefined, fractionDigits = 2): number {
  if (isNull(value) || isUndefined(value)) {
    return 0
  }
  return Number.parseFloat(value.toFixed(fractionDigits))
}

export const addCommaFormatter = (input: number): string => input.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')

export function formatPrice(price: number | null | undefined, showPrefix = true, addComma = true, defaultPrefix = '¥'): string {
  if (isNull(price)) {
    return ''
  }
  if (isUndefined(price)) {
    return ''
  }
  let yuan = 0
  const fen = Math.abs(price)
  const abs = price < 0 ? '-' : ''
  if (!Number.isNaN(fen)) {
    yuan = Big(fen).div(100).round(2, Big.roundHalfUp).toNumber()
  }
  const fmtFn = addComma ? addCommaFormatter : String
  return `${abs}${showPrefix ? defaultPrefix : ''}${fmtFn(yuan)}`
}
export function toFen(price: string | null | undefined | number): number {
  if (isUndefined(price) || isNull(price) || isEmptyString(price)) {
    return 0
  }
  if (isNumber(price)) {
    return toFixed(price * 100, 0)
  }
  return toFixed(Number.parseFloat(price) * 100, 0)
}

export function toYuanNum(fen: number | null | undefined): number {
  if (isNull(fen)) {
    return 0
  }
  if (isUndefined(fen)) {
    return 0
  }
  let yuan = 0
  if (!Number.isNaN(fen)) {
    yuan = Big(fen).div(100).round(2, Big.roundHalfUp).toNumber()
  }

  return yuan
}
